export default __webpack_public_path__ + "static/media/real-life-KICK.9fdce183.mp3";